import * as React from "react";
import {
  Avatar,
  Box, Card, Container, FormControlLabel, MenuItem, Radio, Typography,
} from "@mui/material";
import ButtonComponent from "components/Button";
import RadioButtonFieldComponent from "components/RadioButtonField";
import {
  getButtonData, getRadioButtonData, getSelectFieldData,
    schema,
} from "./helper";

import {getCityListStatic, setCity, getCountriesListStatic, setCountry } from "helpers/utils";
import MockProductList from "components/elements/main/MockProductList";
import CustomSectionCreator from "components/CustomSectionCreator";

import LocationOnIcon from '@mui/icons-material/LocationOn';
import SelectFieldComponent from "components/SelectField";

const ProfileCityEditor = ({
  setState, selectedLocation, updateCountryClicked, updateCityClicked, onCancel, isLoading,
    cities, countries
}) => {

  const { id, city, country } = selectedLocation || {};

  const [blur, setblur] = React.useState({
    city: false
  });

  const onFinishCity = () => {
    setCountry(country, countries);
    setCity(id, cities);
    updateCityClicked({ id, city });
  };

  const hasError = () => {
    try {
      return !schema.validateSync(selectedLocation);
    } catch (err) {
      return true;
    }
  };

  const handleBlur = (field) => {
    setblur({ ...blur, [field]: true });
  };

  const isTouched = () => (blur.city);

  const getError = (field) => {
    if (blur[field] && hasError()) {
      try {
        schema.validateSyncAt(field, selectedLocation);
      } catch (err) {
        return err.message;
      }
    }
    return null;
  };

    const handleSelectFieldChange = (event, field) => {
        setState(event.target.value, field);
        updateCountryClicked(event.target.value);
    };

  const handleRadioButtonChange = (event, field) => {
    setState(event.target.value, field);
  };

  const countryoptions = (countries) ? countries : getCountriesListStatic();

  const countryinputOptions = countryoptions.map((item) => {
    const { countrycode, name } = item;
    return (
        <MenuItem value={countrycode}>{name}</MenuItem>
    );
  });

  const cityoptions = (cities) ? cities : getCityListStatic();

  const cityinputOptions = cityoptions.map((item) => {
    const { id, name } = item;
    return (
      <FormControlLabel value={id} control={<Radio />} label={name} />
    );
  });


    const renderLocationDetail = () => (
        <Container>
            <Box mb={2}>
              {getSelectFieldData(country).map((element) => (
                  <Box className="textfield" m={2}>
                    <SelectFieldComponent
                        label={element.label}
                        value={element.value}
                        options={countryinputOptions}
                        onChange={(event) => handleSelectFieldChange(event, element.onChangeField)}
                    />
                  </Box>
              ))}
          </Box>
            <Box mb={2}>
              {getRadioButtonData(city).map((element) => (
                  <Box className="textfield" m={2}>
                    <RadioButtonFieldComponent
                        required
                        options={cityinputOptions}
                        label={element.label}
                        value={element.value}
                        onChange={(event) => handleRadioButtonChange(event, element.onChangeField)}
                    />
                  </Box>
              ))}
            </Box>
            <Box>
              {getButtonData(onFinishCity, onCancel, hasError, isTouched).map((element) => (
                  <ButtonComponent
                      sx={{
                        m: 2,
                      }}
                      type={element.type}
                      variant={element.variant}
                      onClick={element.onClick}
                      disabled={element.disabled}
                      name={element.name}
                  />
              ))
              }
            </Box>
        </Container>
    );

    return (
        <Container>
            <Container maxWidth="md">
              <CustomSectionCreator title="Change City">
                {isLoading ? <MockProductList /> : renderLocationDetail() }
              </CustomSectionCreator>
            </Container>
        </Container>
    );
};

export default ProfileCityEditor;
